var map = {
	"./accounts.js": "260b",
	"./actions.js": "cb99",
	"./blocks.js": "4066",
	"./bots.js": "f343",
	"./botsChannels.js": "3828",
	"./botsIntegrations.js": "1abc",
	"./botsSkills.js": "ff41",
	"./calls.js": "bfe5",
	"./channels.js": "b4dd",
	"./companies.js": "d5ad",
	"./contacts.js": "92ee",
	"./contactsBlacklist.js": "b3a5",
	"./contactsCategories.js": "abd4",
	"./countries.js": "54e1",
	"./data.js": "6056",
	"./dialogs.js": "0f51",
	"./dialogsMessages.js": "56f2",
	"./dictionaries.js": "808e",
	"./documents.js": "536f",
	"./files.js": "8773",
	"./finance.js": "4512",
	"./imports.js": "b70d",
	"./integrations.js": "7beb",
	"./knowledge.js": "55fe",
	"./languages.js": "a71e",
	"./layout.js": "c21a",
	"./operators.js": "2d8c",
	"./operatorsTariffs.js": "9e53",
	"./orders.js": "c9f0",
	"./payments.js": "8233",
	"./phonesCodes.js": "c782",
	"./products.js": "22ca",
	"./profiles.js": "62e6",
	"./regions.js": "3f51",
	"./reports.js": "2123",
	"./servers.js": "fd80",
	"./sessions.js": "33d1",
	"./skills.js": "6f93",
	"./statistics.js": "0df1",
	"./tariffs.js": "4d15",
	"./tasks.js": "f6df",
	"./trunks.js": "bc04",
	"./trunksPhones.js": "5167",
	"./users.js": "b20d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfa9";